export default __webpack_public_path__ + "assets/models/cd3fc433c18bdf99f90bfb0a01f15300.glb";